import type { App } from 'vue'
import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from '@/shared/api'
import { router } from '../router'

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClient,
}

export function registerPlugins(app: App) {
  app.use(createPinia())
  app.use(router)
  app.use(VueQueryPlugin, vueQueryPluginOptions)
}
